import { DataBean } from "../DataBean";

export class Updatedistribution extends DataBean {



    public async updatetEmployeeIncapacitiesDistribution(accountID:any,year:any,Month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updatetEmployeeIncapacitiesDistribution_Number_Number_Number", [accountID,year,Month]);
    }
}